import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { ControlIcons } from 'owa-control-icons';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-common-strings';
import * as React from 'react';

let styles = require('./FindRecipientInfo.scss');
let classNames = require('classnames/bind').bind(styles);

export interface FindRecipientInfoProps {
    infoType: FindRecipientInfoType;
    highlighted: boolean;
    queryString: string;
    numberOfResults: number;
    searchDirectoryAction?: () => void;
    useTypedAddressAction?: () => void;
}

export enum FindRecipientInfoType {
    Default = 0,
    Searching,
    TypeToSearch,
    SearchDirectory,
    TopNResults,
    UseAddress,
    SuggestedContacts,
    FindPeopleFeedback,
    LinkedInAccountBind,
}

const FindRecipientInfo = (props: FindRecipientInfoProps) => {
    switch (props.infoType) {
        case FindRecipientInfoType.Searching:
            return (
                <div className={styles.container}>
                    <div className={styles.iconContainer}>
                        <Spinner className={styles.loadingSpinner} />
                    </div>
                    <div className={styles.textContainer}>
                        {format(strings.findRecipientInfo_Searching, props.queryString)}
                    </div>
                </div>
            );
        case FindRecipientInfoType.TypeToSearch:
            return (
                <div className={styles.container}>
                    <div className={classNames(styles.textContainer, styles.centered)}>
                        {strings.findRecipientInfo_TypeToSearch}
                    </div>
                </div>
            );
        case FindRecipientInfoType.SearchDirectory:
            return (
                props.searchDirectoryAction && (
                    <div
                        className={classNames(styles.container, styles.hoverable, {
                            isHighlighted: props.highlighted,
                        })}
                        onClick={props.searchDirectoryAction}>
                        <div className={styles.iconContainer}>
                            <Icon className={styles.searchIcon} iconName={ControlIcons.Search} />
                        </div>
                        <div className={styles.textContainer}>
                            {isConsumer()
                                ? strings.findRecipientInfo_SearchPeople
                                : strings.findRecipientInfo_SearchDirectory}
                        </div>
                    </div>
                )
            );
        case FindRecipientInfoType.TopNResults:
            return (
                <div className={styles.container}>
                    <div className={classNames(styles.textContainer, styles.centered)}>
                        {props.numberOfResults
                            ? format(strings.findRecipientInfo_TopNResults, props.numberOfResults)
                            : strings.findRecipientInfo_NoResultsFound}
                    </div>
                </div>
            );
        case FindRecipientInfoType.UseAddress:
            return (
                props.useTypedAddressAction && (
                    <div>
                        <div
                            className={classNames(styles.hoverable, {
                                isHighlighted: props.highlighted,
                            })}>
                            <div
                                className={classNames(
                                    styles.textContainer,
                                    styles.useAddressContainer
                                )}
                                onClick={props.useTypedAddressAction}>
                                {format(
                                    strings.findRecipientInfo_UseThisAddress,
                                    props.queryString
                                )}
                            </div>
                        </div>
                        <FindRecipientInfo
                            infoType={FindRecipientInfoType.TopNResults}
                            highlighted={false}
                            queryString={props.queryString}
                            numberOfResults={props.numberOfResults}
                        />
                    </div>
                )
            );
        default:
            return null;
    }
};

export default FindRecipientInfo;
